export const SET_VIDEOS = 'SET_VIDEOS'
export const SET_POSTERS = 'SET_POSTERS'
